import React, {
  forwardRef,
  isValidElement,
  cloneElement,
  ForwardedRef
} from "react";
import {ButtonType} from "./types";
import {getButtonType, getCssClasses} from "./utils";

export const SVVButton = forwardRef<HTMLButtonElement, ButtonType>(
  function ButtonInternal(
    props: ButtonType,
    ref: ForwardedRef<HTMLButtonElement>
  ) {
    const {
      children,
      loading,
      icon,
      loadingString,
      // Fjern props fra restProps. React gir en warning hvis disse sendes
      // til <button> vha {...restProps}
      // eslint-disable-next-line
      small,
      // eslint-disable-next-line
      looksLikeLink,
      // eslint-disable-next-line
      iconPlacement,
      // eslint-disable-next-line
      color,
      ...restProps
    } = props;

    return (
      <button
        ref={ref}
        {...restProps}
        className={getCssClasses(props)}
        // Overskrive type fra restProps
        type={getButtonType(props)}
      >
        {icon && isValidElement(icon) && cloneElement(icon, {"aria-hidden": true})}
        <span aria-live="assertive" className="svv-button--loading-span">
          {loading ? `${loadingString}` : ""}
        </span>
        {children}
      </button>);
  }
);

SVVButton.displayName = "SVVButton";
